"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerfGroupTimeChart = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const Measure_1 = __importDefault(require("@opsbase/lib-chart/Measure"));
const useDimensions_1 = __importDefault(require("@opsbase/react-hooks/useDimensions"));
const Line3DGrouped_1 = __importDefault(require("@opsbase/web-charts/Line3DGrouped"));
const Table3D_1 = __importDefault(require("@opsbase/web-charts/Table3D"));
const react_1 = __importStar(require("react"));
const ChartPane_1 = __importDefault(require("../ChartPane"));
const usePerfGroupTimeChart_1 = __importDefault(require("./usePerfGroupTimeChart"));
function PerfGroupTimeChart({ chart, width, height, onClickValue }) {
    const { dimension, measure, interval } = chart === null || chart === void 0 ? void 0 : chart.config;
    const { data, loading } = (0, usePerfGroupTimeChart_1.default)(dimension, measure, interval);
    const [paneRef, paneDims] = (0, useDimensions_1.default)();
    const onClickDatum = (0, react_1.useCallback)((e, v) => {
        const datum = v.datum;
        onClickValue({ v: datum.y, x: datum.xDim, y: datum.yDim });
    }, [onClickValue]);
    const chartBit = (0, react_1.useMemo)(() => {
        var _a;
        if (loading || !data || !paneDims)
            return null;
        const xLabels = ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.map(d => (d.xDim.label + '').split(' - ').join('\n'))) || [];
        const highIsBad = measure === Measure_1.default.MISSED || measure === Measure_1.default.LATE;
        const chartProps = Object.assign({ width: paneDims.width, height: paneDims.height, data,
            xLabels, ySuffix: '%', conditionalFormating: {
                bad: highIsBad ? 100 : 0,
                good: highIsBad ? 0 : 100,
            } }, (onClickValue ? { onClickDatum } : {}));
        if (chart.chartType === ChartType_1.default.TABLE3D)
            return react_1.default.createElement(Table3D_1.default, Object.assign({}, chartProps));
        if (chart.chartType === ChartType_1.default.LINE3DGROUP)
            return react_1.default.createElement(Line3DGrouped_1.default, Object.assign({}, chartProps));
    }, [loading, data, paneDims, measure, onClickValue, onClickDatum, chart.chartType]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(ChartPane_1.default, { style: { alignItems: 'flex-start' }, grow: true, ref: paneRef, loading: loading, width: width, height: chart.chartType === ChartType_1.default.TABLE3D ? 'auto' : height }, chartBit)), [paneRef, loading, width, chart.chartType, height, chartBit]);
}
exports.PerfGroupTimeChart = PerfGroupTimeChart;
exports.default = PerfGroupTimeChart;
